import { render, staticRenderFns } from "./increaseloan.vue?vue&type=template&id=60ce5bc6&scoped=true&"
import script from "./increaseloan.vue?vue&type=script&lang=js&"
export * from "./increaseloan.vue?vue&type=script&lang=js&"
import style0 from "./increaseloan.vue?vue&type=style&index=0&id=60ce5bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce5bc6",
  null
  
)

export default component.exports